// raceRefBus — persistente Referenz auf die "Originalstrecke".
//
// Wenn der Fahrer im RIDE-Modus einer Rennstrecke folgt und einen Pit-Stop
// sucht, merken wir uns HIER die Originalstrecke. Im Gegensatz zu routeBus
// (das beim Verlassen der Karte geleert und beim Detour-Ride überschrieben
// wird) bleibt diese Referenz bestehen — damit man im Planer UND während der
// Umweg-Fahrt immer sieht, wo der eigentliche Kurs langgeht.
//
// In-Memory-Singleton (überlebt Navigation, nicht aber einen harten Reload —
// das ist für eine Renn-Session okay). [lat, lon, ele?] wie routeBus.

import type { RoutePoint } from './routeBus';

type Listener = (route: RoutePoint[] | null) => void;

class RaceRefBus {
  private current: RoutePoint[] | null = null;
  private readonly listeners = new Set<Listener>();

  get(): RoutePoint[] | null {
    return this.current;
  }
  set(route: RoutePoint[] | null): void {
    this.current = route && route.length > 1 ? route : null;
    for (const l of this.listeners) l(this.current);
  }
  subscribe(listener: Listener): () => void {
    this.listeners.add(listener);
    return () => {
      this.listeners.delete(listener);
    };
  }
}

export const raceRefBus = new RaceRefBus();
